import { Row, Col, Card, Typography, Button } from "antd";
import { useNavigate } from "react-router";
import BookmarkList from "./BookmarkList";
import RecentlyVisited from "./RecentlyVisited";
import AdvancedSearch from "./AdvancedSearch";

const DashboardContent = () => {
  const navigate = useNavigate();
  // Antd
  const { Title } = Typography;

  // Styles
  const colStyle = {
    paddingLeft: 10,
    paddingRight: 10,
    borderRight: "1px solid lightgrey",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <Row gutter={6} style={{ padding: 5 }}>
        <Col span={8} style={colStyle}>
          <RecentlyVisited />
        </Col>
        <Col span={8} style={colStyle}>
          <BookmarkList />
        </Col>
        <Col span={8}>
          <AdvancedSearch />
        </Col>
      </Row>
    </div>
  );
};

export default DashboardContent;

